import { em } from 'polished'
import styled from 'styled-components'

export const ItemsWrapper = styled.div`
  margin-bottom: ${em(20)};
`
